import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-bestand',
  templateUrl: './form-bestand.component.html',
  styleUrl: './form-bestand.component.scss',
  standalone: false
})
export class FormBestandComponent {
  formDisabled = false;

  @Input() attachForm?: FormGroup;
  @Input() isStorno?: boolean;

  @Input() set disabled(formDisabled: boolean) {
    this.formDisabled = formDisabled;
  }
}
